import { Expose, Type } from 'class-transformer';
import { GetCancellationPolicyOptionDto } from './get-cancellation-policy-option.dto';
import { PolicyStatusEnum } from '../../../../store/PolicyManagement/enums/policy-status.enum';

export class GetCancellationPolicyResponseDto {
  @Expose({ name: 'id' })
  id: number;
  @Expose({ name: 'name' })
  name: string;
  @Expose({ name: 'description' })
  description: string;
  @Expose({ name: 'event_default' })
  eventDefault: boolean;
  @Expose({ name: 'booking_default' })
  bookingDefault: boolean;
  @Expose({ name: 'status' })
  status: PolicyStatusEnum;
  @Expose({ name: 'options' })
  @Type(() => GetCancellationPolicyOptionDto)
  options: GetCancellationPolicyOptionDto[];
}
